

import React from "react";
import { GiRotaryPhone } from "react-icons/gi";
import { ImChrome } from "react-icons/im";
import { FaSquareThreads } from "react-icons/fa6";

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import "./Footer.css";
import { NavLink } from "react-router-dom";

const logo = "./main_logos.png";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LEFT */}
        <div className="footer-col brand">
          <img src={logo} alt="BrightNok" className="footer-logo" />
          <p>
            Fresh N Clean Laundry provides premium washing and dry cleaning
            service leveraging mobile based technology. We provide high quality
            and is the world leader in dry cleaning and laundry operating in
            Available in **Dubai** and **Abu Dhabi**.
          </p>
          <div className="social-icons-footer">
            <a href="https://www.facebook.com/share/1BYEnr3gtA/" target="block">
              <FaFacebookF />
            </a>
            <a href="https://www.threads.com/@fnclaundryofficial" target="block">
              <FaSquareThreads />
            </a>
            <a href="https://www.instagram.com/fnclaundryofficial"target="block">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/@fnclaundryofficial"target="block">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/company/fnclaundryofficial/" target="block">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* SERVICES */}
        <div className="footer-col">
          <h3>Services</h3>
          <ul>
            <li>
              <NavLink
                to="/expert-services"
                onClick={scrollToTop}
                style={{ textDecoration: "none" }}
              >
                <p>Clean & Press</p>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/press-only"
                style={{ textDecoration: "none" }}
                onClick={scrollToTop}
              >
                <p> Press Only</p>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/drycleaning"
                style={{ textDecoration: "none" }}
                onClick={scrollToTop}
              >
                <p>Dry Cleaning</p>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/washfold"
                style={{ textDecoration: "none" }}
                onClick={scrollToTop}
              >
                <p>Wash & Fold</p>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/whiteplus"
                style={{ textDecoration: "none" }}
                onClick={scrollToTop}
              >
                <p>White+</p>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/monthly-plans"
                style={{ textDecoration: "none" }}
                onClick={scrollToTop}
              >
                <p>Wash & Fold</p>
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/finishing" onClick={scrollToTop}
                style={{ textDecoration: "none" }}>
                <p>Robe Finishing</p>
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to="/expert-services"
                onClick={scrollToTop}
                style={{ textDecoration: "none" }}
              >
                <p>Clean & Press</p>
              </NavLink>
            </li>
          </ul>
        </div>

        {/* USEFUL LINKS */}
        <div className="footer-col">
          <h3>Usefull link</h3>
          <ul>
            <li>
              <NavLink to="/about" className="nav-link" onClick={scrollToTop}>
                About Us
              </NavLink>
            </li>

            {/* <li>
              <NavLink to="/sustainability" className="nav-link" onClick={scrollToTop}>
                Sustainability
              </NavLink>
            </li> */}

            <li>
              <NavLink
                to="/service-sreas"
                className="nav-link"
                onClick={scrollToTop}
              >
                Service Areas
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/laundry-price"
                className="nav-link"
                onClick={scrollToTop}
              >
                Prices
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/faqloundry-qustions"
                className="nav-link"
                onClick={scrollToTop}
              >
                FAQs
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/conditions-teams"
                className="nav-link"
                onClick={scrollToTop}
              >
                Terms & Conditions
              </NavLink>
            </li>

            {/* <li>
              <NavLink to="/consultation-form" className="nav-link" onClick={scrollToTop}>
                ConsultationForm
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to="/contactus"
                className="nav-link"
                onClick={scrollToTop}
              >
                Contact Us
              </NavLink>
            </li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h3>Contact Us</h3>

          <p>
            <a href="tel:0545718455" className="contact-item">
              <FaPhoneAlt /> 0545718455
            </a>
          </p>

          <p>
            <a href="tel:065618455" className="contact-item">
              <GiRotaryPhone /> 065618455
            </a>
          </p>

          <p>
            <a href="mailto:info@fnclaundry.com" className="contact-item">
              <FaEnvelope /> info@fnclaundry.com
            </a>
          </p>

          <p>
            <a
              href="https://www.fnclaundry.com"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item"
            >
              <ImChrome /> www.fnclaundry.com
            </a>
          </p>

          <p>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Al+Yasmeen+Opposite+of+Al+Rahmania+Ajman"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item"
            >
              <FaMapMarkerAlt /> AI Yasmeen, Opposite of AI Rahmania, Ajman
            </a>
          </p>
        </div>
        <a
          href="https://api.whatsapp.com/send?phone=971545718455"
          target="_blank"
          rel="noreferrer"
          className="float whatsapp"
        >
          <i className="fa-brands fa-whatsapp"></i>
        </a>

        <div className="float chat">💬</div>
      </div>

      <div className="footer-bottom">
        © Fresh N Clean Private Limited {new Date().getFullYear()} | All rights
        reserved.
      </div>
    </footer>
  );
}
